import { render, staticRenderFns } from "./ContentUnavailablePage.vue?vue&type=template&id=19bb0754&scoped=true"
import script from "./ContentUnavailablePage.vue?vue&type=script&lang=js"
export * from "./ContentUnavailablePage.vue?vue&type=script&lang=js"
import style0 from "./ContentUnavailablePage.vue?vue&type=style&index=0&id=19bb0754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bb0754",
  null
  
)

export default component.exports